<mat-dialog-content>
  <lemon-dialog-header>
    <span>Lisää uusi kirjanpitäjä</span>
  </lemon-dialog-header>

  <div style="padding: 0 2em">
    <form novalidate>
      <mat-form-field>
        <mat-label>Etunimi</mat-label>
        <input type="text" [formField]="lomake.etunimi" matInput cdkFocusInitial />
        @if (naytaVirhe(lomake.etunimi, 'required')) {
          <mat-error>Etunimi puuttuu</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>Sukunimi</mat-label>
        <input type="text" [formField]="lomake.sukunimi" matInput />
        @if (naytaVirhe(lomake.sukunimi, 'required')) {
          <mat-error>Sukunimi puuttuu</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>Microsoft-tunnuksen UID</mat-label>
        <input type="text" [formField]="lomake.msUid" matInput />
        @if (naytaVirhe(lomake.msUid, 'required')) {
          <mat-error>Microsoft-tunnuksen UID puuttuu</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>Sähköpostiosoite</mat-label>
        <input type="text" [formField]="lomake.email" matInput />
        @if (naytaVirhe(lomake.email, 'required')) {
          <mat-error>Sähköpostiosoite puuttuu</mat-error>
        }
        @if (naytaVirhe(lomake.email, 'email')) {
          <mat-error>Sähköpostiosoite on virheellinen</mat-error>
        }
        @if (naytaVirhe(lomake.email, 'email-varattu')) {
          <mat-error>Sähköpostiosoite on jo käytössä toisella kirjanpitäjällä</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>Puhelinnumero</mat-label>
        <input type="text" [formField]="lomake.puhelin" matInput />
        @if (naytaVirhe(lomake.puhelin, 'pattern')) {
          <mat-error>Numero on virheellinen</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>Aloitti</mat-label>
        <input type="text" [matDatepicker]="aloittiPicker" [formField]="lomake.aloitti" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="aloittiPicker"></mat-datepicker-toggle>
        <mat-datepicker #aloittiPicker startView="month"></mat-datepicker>
        @if (naytaVirhe(lomake.aloitti, 'required')) {
          <mat-error>Lisää aloituspäivä</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>Toimipiste</mat-label>
        <mat-select [formField]="lomake.toimipiste">
          @for (piste of kaikkiToimipisteet; track piste.avain) {
            <mat-option [value]="piste.avain">{{ piste.nimi }}</mat-option>
          }
        </mat-select>
        @if (naytaVirhe(lomake.toimipiste, 'required')) {
          <mat-error>Valitse toimipiste</mat-error>
        }
      </mat-form-field>

      @if (naytaRooliKenttaObservable | async) {
        <mat-form-field>
          <mat-label>Rooli</mat-label>
          <mat-select [formField]="lomake.rooli">
            <mat-option [value]="null">(ei roolia)</mat-option>
            <mat-option [value]="KirjanpitajanRooli.TAVALLINEN">Tavallinen</mat-option>
            <mat-option [value]="KirjanpitajanRooli.SUPER">Super</mat-option>
            <mat-option [value]="KirjanpitajanRooli.TAVALLINEN_JA_HOLVI">Tavallinen + Holvi</mat-option>
          </mat-select>
          <mat-hint>Tyhjä = kirjanpitäjä ei pääse kirjautumaan</mat-hint>
        </mat-form-field>
      }

      <div style="margin-top: 10px">
        <mat-checkbox [formField]="lomake.tutkintoKlt">KLT</mat-checkbox>
      </div>
    </form>

    @if (commonError()) {
      <div class="error-text" style="margin-top: 10px">{{ commonError() }}</div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions style="padding: 0 2em 1em; display: flex; justify-content: space-between">
  <app-secondary-button (click)="peruuta()" actionId="Peruuta uuden kirjanpitäjän lisäys">Peruuta</app-secondary-button>
  <app-primary-button (click)="tallenna()" actionId="Tallenna uusi kirjanpitäjä" [actionContext]="[lomake().value()]">Tallenna</app-primary-button>
</mat-dialog-actions>
